import { gsap } from "gsap";
import axios from "axios";
import CharacterData from "../../../data/character.json";

import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class Character {
    constructor() {
        this.init();
    }

    init() {
        this.onmousemove();
        this.switchEvent();

        //chara初期設定
        this.changeCharacter("1", true);
    }

    onmousemove() {
        const charaPh = [...document.querySelectorAll(".js-characterph")];

        if (window.innerWidth >= 835) {
            window.addEventListener("mousemove", (e) => {
                const x_pos = window.innerWidth / 2 - e.clientX;
                const y_pos = window.innerHeight / 2 - e.clientY;

                charaPh.forEach((el) => {
                    gsap.to(el, { x: -x_pos / 50, y: -y_pos / 50, duration: 1 });
                });
            });
        }
    }

    switchEvent() {
        const buttons = document.querySelectorAll(".js-character_switch");

        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                const tgt = button.getAttribute("data-character");
                this.changeCharacter(tgt);
            });
        });
    }

    setTwitterWidgets(character) {
        //twitterウィジェット更新
        // コンテナを取得
        const container = document.querySelector(".js-twitter_timeline");
        container.classList.remove("-loaded");
        container.innerHTML = "";

        const setEvent = (wrapper) => {
            const lists = [...wrapper.querySelectorAll(".c-twitter_timeline__list__item")];
            const lists_atag = [...wrapper.querySelectorAll(".c-twitter_timeline__list__item a")];

            lists.forEach((item) => {
                item.addEventListener("click", (e) => {
                    window.open(item.getAttribute("data-link"), "_blank");
                });
            });

            lists_atag.forEach((item) => {
                item.addEventListener("click", (e) => {
                    e.stopPropagation();
                });
            });
        };

        const set = (character) => {
            axios({
                method: "GET",
                url: `./_inc/twitter/${character.name_id}.html`,
                responseType: "document",
            }).then((res) => {
                const timeline = res.data.body.querySelector(".c-twitter_timeline__list");
                container.appendChild(timeline);
                container.classList.add("-loaded");
                gsap.fromTo(timeline, { opacity: 0 }, { opacity: 1, duration: 0.5, delay: 0.3 });
                setEvent(timeline);
            });
        };

        set(character);
    }

    changeCharacter(tgt, initialSet) {
        let character = CharacterData.filter((el) => el.id === tgt)[0];

        const wrapper = document.querySelector(".character__field");
        const name = document.querySelector(".js-ch-name");
        const enname = document.querySelector(".js-ch-enname");
        const elmname = document.querySelector(".js-ch-elmname");
        const twname = document.querySelector(".js-ch-twname");
        const twlink = document.querySelector(".js-ch-twlink");
        const chlink = document.querySelector(".js-ch-chlink");
        const prev = [...document.querySelectorAll(".js-character_prev")];
        const next = [...document.querySelectorAll(".js-character_next")];

        const nav = [...document.querySelectorAll(".js-character_nav")];

        nav.forEach((el) => {
            el.classList.remove("-active");
            if (el.getAttribute("data-character") === tgt) {
                el.classList.add("-active");
            }
        });

        //名前系
        name.textContent = character.name;
        enname.textContent = character.name_en;
        elmname.textContent = character.element;
        twname.textContent = character.twitter;
        twlink.setAttribute("href", `https://twitter.com/${character.twitter}`);

        wrapper.setAttribute("data-character", tgt);
        wrapper.classList.add("-change");

        //linkの更新
        chlink.setAttribute("href", character.profile_link);

        //prev,nextの更新
        prev.forEach((el) => el.setAttribute("data-character", character.prev));
        next.forEach((el) => el.setAttribute("data-character", character.next));

        setTimeout(() => {
            wrapper.classList.remove("-change");
        }, 1000);

        if (!initialSet) {
            //キャラのスクロールをリセット（小さいブラウザ用）
            if (window.innerWidth >= 835) {
                gsap.to(window, { duration: 0.4, scrollTo: { y: "#character", offsetY: -95 }, ease: "circ.out" });
            }
        }

        //twitterウェジットをセット
        this.setTwitterWidgets(character);
    }
}
